<div class="row ui-sortable">
    <div class="col-xs-12 col-sm-12">
		<div class="card-box m-b-5">
			<div class="row">
				<div class="col-xs-10">
					<h4 class="text-dark wide-heading">{{name}}</h4>
					<div class="row">
						<div class="col-xs-12 col-sm-3">
							<em>{{TR "Beschreibung"}}</em>
						</div>
						<div class="col-xs-12 col-sm-9">
							{{#if description}}{{description}}{{else}}--{{/if}}
						</div>
					</div>
					<div class="row m-t-10">
						<div class="col-xs-12 col-sm-3">
							<em>{{TR "Filter"}}</em>
						</div>
						<div class="col-xs-12 col-sm-9">
							{{{filter}}}
						</div>
					</div>
					<div class="row m-t-10">
						<div class="col-xs-12 col-sm-3">
							<em>{{TR "Inhalt"}}</em>
						</div>
						<div class="col-xs-12 col-sm-9">
							<ul class="content-list">
								{{#each fields}}
								<li class="ui-sortable">
									<i class="{{type_icon}} m-r-5"></i>
									{{name}}
								</li>
								{{/each}}
							</ul>
						</div>
					</div>
					{{#if show_sort_col}}
					<div class="row">
						<div class="col-xs-12 col-sm-9 col-sm-offset-3">
							{{#if sort_desc}}{{TR "Absteigend sortiert nach"}}{{else}}{{TR "Sortiert nach"}}{{/if}}
							{{sort_col_name}}
							{{#COMPARE limit '>' 0}}({{TR "Top"}} {{limit}}){{/COMPARE}}
						</div>
					</div>
					{{/if}}
				</div>
				<div class="col-xs-2">
					<div class="pull-right">
						<button class="btn btn-sm btn-white js-edit m-b-5">
							<i class="fa fa-cog"></i>
						</button>
						<br>
						{{#unless isCSVreport}}
						<button class="btn btn-sm btn-white js-up {{#if is_first}}disabled{{/if}}" {{#if is_first}} disabled="disabled"{{/if}}>
							<i class="fa fa-arrow-up"></i>
						</button>
						<br>
						<button class="btn btn-sm btn-white js-down m-b-5 {{#if is_last}}disabled{{/if}}"{{#if is_last}} disabled="disabled"{{/if}}>
							<i class="fa fa-arrow-down"></i>
						</button>
						<br>
						{{/unless}}
						<button class="btn btn-sm btn-white js-delete">
							<i class="fa fa-trash"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
    </div>
</div>
